'use strict'

import React from 'react'

const config = {
    plugins: {
        react: {
            resources: [
                { src: "#{paths.plugins}react/libs/react.js", debug: "#{paths.plugins}react/libs/react.js", type: "text/javascript" },
                { src: "#{paths.plugins}react/React.min.css", debug: "#{paths.plugins}react/React.css", type: "text/css" },
                { src: "#{paths.plugins}react/React.js", debug: "#{paths.plugins}react/React.js", type: "text/javascript" }
            ],
            theme: {
                "text": "rgba(255,255,255,0.85)",
                "foreground": "rgba(255,255,255,0.85)",
                "background": "rgba(33, 33, 33, 1)"
            },
            autoHide: 3,
            mode: "fixed"
        }
    },
    autoplay: false,
    media: {
        src: "https://mdtp-a.akamaihd.net/customers/akamai/video/VfE.mp4",
        track: [
            { src: "https://mdtp-a.akamaihd.net/preview/VfE.vtt", type: "text/vtt", kind: "preview" }
        ]
    },
    hls: {
        quality: {
            startLevel: 5
        },
        data: {
            enableWorker: true
        }
    },
    playsinline: true
};

class PlayerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { src: '' };
    }

    componentDidMount() {
        console.log('AMP PLAYER VERSION ', akamai.amp.AMP.VERSION);
        akamai.amp.AMP.create("#akamai-player", config, (event) => {
            this.player = event.player
        });
    }

    componentWillReceiveProps(props) {

    }

    render() {
        const object = this.props.data;
        const hidden = this.props.hidden;

        if (this.player) {
            let theme = Object.assign({}, this.player.react.theme);

            for (const key in object) {
                if (object.hasOwnProperty(key) && theme.hasOwnProperty(key)) {
                    const element = object[key];
                    theme[key] = element.value;
                }
            }
            if ('individual' == hidden) {
                this.player.react.theme = {
                    "text": "rgba(255,255,255,0.85)",
                    "foreground": "rgba(255,255,255,0.85)",
                    "background": "rgba(33, 33, 33, 1)"
                }
            }
            else {
                this.player.react.theme = theme;
            }

        }

        return (
            <div id="player-container" className={this.props.src} >
                <div id="akamai-player" />
            </div>
        )
    }
}

export default PlayerComponent